import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { PromoPageKeys } from 'sections/PromoSection/pages/PromoPage/types'
import { Href } from 'components/ui/Href/Href'
import { Flex } from 'components/uiKit'
import { PromoGeRoutesEnum } from 'shared/constants/routes'
import { URLS } from 'shared/constants/urls'

import logo from 'assets/img/promo-page/wb-logo.webp'
import s from './FooterNew.module.scss'

export const FooterNew: FC = () => {
  const { t } = useTranslation()
  const getKey = (key: string) => `${PromoPageKeys.shared}.${key}`

  return (
    <footer className={s.footer}>
      <img src={logo} alt="logo" className={s.logo} />
      <Flex justify="center" align="end">
        <Href className={s.policyLink} href={URLS.wbMarketPrivatePolicyGe} linkType="pathname" target="_blank">
          {t(getKey('Политика конфиденциальности'))}
        </Href>
      </Flex>
      <Href className={s.link} href={PromoGeRoutesEnum.apps} type="text">
        {t(getKey('Приложения'))}
      </Href>
    </footer>
  )
}
